import React, { useEffect, useState } from 'react';
import HiringSection from './HiringSection';
import { useHiringAssessmentDashboard } from 'src/hooks/hiringAssessment.hooks';

const PositionHiringSection = () => {
	const [positionArray, setPositionArray] = useState([
		{ id: 1, process: 'Positions', count: 0 },
		{ id: 2, process: 'Shortlisted', count: 0 },
		{ id: 3, process: 'Opted In', count: 0 },
		{
			id: 4,
			process: 'In Process',
			count: 0,
			positionData: { assessmentPending: 0, interviewing: 0, rejected: 0 },
		},
		{ id: 5, process: 'Hired', count: 0 },
		{ id: 6, process: 'Rejected', count: 0 },
	]);
	const { data: hiringAssessmentDashboardData, isLoading: hiringAssessmentDashboardDataLoading } =
		useHiringAssessmentDashboard();

	useEffect(() => {
		if (hiringAssessmentDashboardData?.result) {
			setPositionArray([
				{ ...positionArray[0], count: hiringAssessmentDashboardData?.result?.allPositions },
				{ ...positionArray[1], count: hiringAssessmentDashboardData?.result?.allShortlistedApplications },
				{ ...positionArray[2], count: hiringAssessmentDashboardData?.result?.allOptedInApplications },
				{ ...positionArray[3], count: hiringAssessmentDashboardData?.result?.allInProgressApplications },
				{ ...positionArray[4], count: hiringAssessmentDashboardData?.result?.allHiredApplications },
				{ ...positionArray[5], count: hiringAssessmentDashboardData?.result?.allRejectedApplications },
			]);
		}
	}, [hiringAssessmentDashboardData]);
	return (
		<HiringSection
			heading="Jobs overview"
			subheading="Check, edit and update the status of all your current open positions"
			positions={positionArray}
			linkUrl="/recruiter-dashboard/positions"
			linkText="View details →"
			logoSrc="/assets/recruiterDashboard/positionhiring.svg"
		/>
	);
};

export default PositionHiringSection;
